import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=826b3878&scoped=true&"
import script from "./OnboardingLayout.vue?vue&type=script&lang=ts&"
export * from "./OnboardingLayout.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=826b3878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826b3878",
  null
  
)

export default component.exports